'use client';

import { aiChatOpenAtom, blackTransparentLoaderModalAtom } from '@/atom/modal';
import SpinnerLoader1818 from '@svg/common/spinner_loader_18_18.svg';
import { useAtom, useAtomValue } from 'jotai';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function BlackTransparentLoaderModal() {
  const pathname = usePathname();

  const [blackTransparentLoaderModal, setBlackTransparentLoaderModal] = useAtom(blackTransparentLoaderModalAtom);
  const isChatOpen = useAtomValue(aiChatOpenAtom);

  useEffect(() => {
    setBlackTransparentLoaderModal(false);
  }, [pathname]);

  useEffect(() => {
    if (!blackTransparentLoaderModal) {
      return;
    } else {
      const isNotHidden = document.body.style.overflowY !== 'hidden';
      if (isNotHidden) {
        document.body.style.overflowY = 'hidden';
      }

      return () => {
        if (isNotHidden) document.body.style.overflowY = 'auto';
      };
    }
  }, [blackTransparentLoaderModal]);

  if (!blackTransparentLoaderModal) {
    return null;
  }

  return (
    <div
      className={`fixed w-full top-0 z-[100] h-dvh overflow-hidden bg-custom-black/60 flex items-center justify-center animate-[fadeIn_300ms_ease-in-out] ${
        isChatOpen ? 'max-w-[960px] left-1/2 -translate-x-1/2' : 'max-w-480pxr'
      }`}
    >
      <SpinnerLoader1818 className='animate-spin' />
    </div>
  );
}
